<p-dialog
  [(visible)]="isVisible"
  [modal]="true"
  [resizable]="false"
  [closable]="false"
  [closeOnEscape]="true"
  [draggable]="false"
  [style]="{ width: '42%', display: 'flex', flexDirection: 'column' }">
  <ng-template pTemplate="header">
    <div class="header-name ml-auto mr-auto p-4 bg-lightest rounded-md w-full">
      <h1 class="white-space-nowrap text-xl flex justify-center font-app-bold text-darkest">
        {{ "paymentInfo.ibanModificationTitle" | translate }}
      </h1>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="flex flex-column w-full">
      <!-- Titulaire -->
      <div class="flex items-center w-full p-1">
        <span class="font-app-regular text-dark text-sm md:text-base w-1/4">
          {{ "paymentInfo.paymentOwner" | translate }}
        </span>
        <div class="ml-auto">
          <p-dropdown
            [options]="optionsOwner"
            [(ngModel)]="isOwner"
            appendTo="body"
            class="classic-dropdown"></p-dropdown>
        </div>
      </div>
      <!-- Apply All Account -->
      <div
        *ngIf="hasMemberMultipleReferences"
        class="flex items-center w-full p-1">
        <span class="font-app-regular text-dark text-sm md:text-base">
          {{ "paymentInfo.ibanApplyAll" | translate }}
        </span>
        <div class="ml-auto">
          <p-dropdown
            [options]="optionsAllContract"
            [(ngModel)]="allContractSelection"
            appendTo="body"
            class="classic-dropdown"></p-dropdown>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex justify-around items-center">
      <button
        pButton
        type="button"
        label="Annuler"
        class="bg-white border-primary w-1/3 border-solid border-[1px] p-3 text-primary"
        (click)="cancel()"></button>
      <button
        pButton
        type="button"
        label="Valider"
        class="bg-primary text-white w-1/3 p-3 pr-8"
        (click)="validate()"></button>
    </div>
  </ng-template>
</p-dialog>

